/**
 * Animated Graphic — Frontend.
 *
 * CSS is enqueued as a normal stylesheet. JS loads from an external file
 * when the block scrolls into view (IntersectionObserver).
 * Targets the stable `.ko-animated-graphic` class (survives KO Blocks merge).
 */
( function () {
	'use strict';

	function run() {
		var blocks = document.querySelectorAll(
			'.ko-animated-graphic[data-has-js="1"]'
		);

		blocks.forEach( function ( block ) {
			if ( block.dataset.koAgInit ) {
				return;
			}
			block.dataset.koAgInit = '1';

			var src = block.getAttribute( 'data-ko-ag-js-src' );
			if ( ! src ) {
				return;
			}

			if ( typeof IntersectionObserver === 'undefined' ) {
				loadScript( src );
				return;
			}

			var observer = new IntersectionObserver(
				function ( entries ) {
					entries.forEach( function ( entry ) {
						if ( entry.isIntersecting ) {
							loadScript( src );
							observer.unobserve( block );
						}
					} );
				},
				{ threshold: 0.1 }
			);

			observer.observe( block );
		} );
	}

	function loadScript( src ) {
		if ( document.querySelector( 'script[data-ko-ag-src="' + src + '"]' ) ) {
			return;
		}
		var s = document.createElement( 'script' );
		s.src = src;
		s.async = true;
		s.setAttribute( 'data-ko-ag-src', src );
		document.body.appendChild( s );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', run );
	} else {
		run();
	}
} )();
